var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-config"},_vm._l((_vm.componentList),function(item,key){return _c('div',{key:key},[(item.index === _vm.index)?_c(item.name,{tag:"component"}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }